
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/calendar/jst/reservationOverLimitDialog';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.reservation_over_limit_dialog")
  },data:data},helper ? helper.call(depth0, "calendar.reservation_over_limit_dialog.cancel_existing_reservation", "Cancel existing reservation and sign up for this one?", options) : helperMissing.call(depth0, "t", "calendar.reservation_over_limit_dialog.cancel_existing_reservation", "Cancel existing reservation and sign up for this one?", options)))
    + "\n  ";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.reservation_over_limit_dialog")
  },data:data},helper ? helper.call(depth0, "calendar.reservation_over_limit_dialog.appointment_limit_reached", "Appointment limit reached", options) : helperMissing.call(depth0, "t", "calendar.reservation_over_limit_dialog.appointment_limit_reached", "Appointment limit reached", options)))
    + "\n  ";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <div>\n      "
    + escapeExpression((helper = helpers.semanticDateRange || (depth0 && depth0.semanticDateRange),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.start_at), (depth0 && depth0.end_at), options) : helperMissing.call(depth0, "semanticDateRange", (depth0 && depth0.start_at), (depth0 && depth0.end_at), options)))
    + "\n    </div>\n  ";
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.reservation_over_limit_dialog")
  },data:data},helper ? helper.call(depth0, "calendar.reservation_over_limit_dialog.would_you_like_to_cancel_that_and_sign_up_for_this", "Would you like to cancel that and sign up for this?", options) : helperMissing.call(depth0, "t", "calendar.reservation_over_limit_dialog.would_you_like_to_cancel_that_and_sign_up_for_this", "Would you like to cancel that and sign up for this?", options)))
    + "\n  ";
  return buffer;
  }

function program9(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.past_appointments), {hash:{},inverse:self.noop,fn:self.program(10, program10, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  return buffer;
  }
function program10(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.reservation_over_limit_dialog")
  },data:data},helper ? helper.call(depth0, "calendar.reservation_over_limit_dialog.cancel_some_appointments_and_try_again", "Please cancel one of your other reservations and try again.", options) : helperMissing.call(depth0, "t", "calendar.reservation_over_limit_dialog.cancel_some_appointments_and_try_again", "Please cancel one of your other reservations and try again.", options)))
    + "\n    ";
  return buffer;
  }

  buffer += "<div title=\"\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.reschedulable), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n\n  "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.reservation_over_limit_dialog")
  },data:data},helper ? helper.call(depth0, "calendar.reservation_over_limit_dialog.you_are_already_signed_up_for", "You are already signed up for:", options) : helperMissing.call(depth0, "t", "calendar.reservation_over_limit_dialog.you_are_already_signed_up_for", "You are already signed up for:", options)))
    + "<br>\n  ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.reservations), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.reschedulable), {hash:{},inverse:self.program(9, program9, data),fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  